import React from 'react'
import DiamondBalance from '../DiamondBalance'
import DiamondForm from '../DiamondForm'

const TopUpDiamondMain: React.FC<PropType> = () => {
  return (
    <div>
      <DiamondBalance />
      <DiamondForm />
    </div>
  )
}

interface PropType {}

export default TopUpDiamondMain
